module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.8514/images/blob.svg"